var module = angular.module('octopusApp.environments');

module.directive('machinePolicyEditor', function() {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: 'areas/environments/machinepolicies/views/editor.html'
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/environments/machinepolicies/directives/machine_policy_editor.js
// module id = 820188483009295
// module chunks = 1